module.exports = __webpack_public_path__ + "img/wiley.48e7b119.jpg";